<template>
  <FsTooltip
    ref="accountRef"
    :teleport="false"
    placement="bottom-end"
    trigger="hover"
    :offset-y="11"
    :popper-content-style="{
      width: '288px',
      maxWidth: '288px',
      padding: '16px',
      borderRadius: '8px',
    }"
  >
    <a class="account_icon" href="javascript:;">
      <img :src="accountImg" alt="Account" class="iconfont_nav" />
    </a>
    <template #content>
      <h3 class="welcome">Hi,{{ userInfo?.customers_firstname }}</h3>
      <div class="account_menu">
        <a
          v-for="item in accountMenu"
          :key="item.path"
          href="javascript:;"
          @click.prevent.stop="click(item)"
          @mouseenter="isSignOutHover = true"
          @mouseleave="isSignOutHover = false"
          >{{ item.title }}</a
        >
        <span class="splitLine"></span>
        <span
          class="signOut"
          @click="signOut"
          @mouseenter="isSignOutHover = true"
          @mouseleave="isSignOutHover = false"
          >{{ t('components/layout.accountSignOut') }}</span
        >
      </div>
    </template>
  </FsTooltip>
</template>
<script setup lang="ts">

import { reactive, ref, computed } from 'vue'
import { useUserStore } from '@/store/user'
import { storeToRefs } from 'pinia'
import { handleFsLink } from '@/utils'
import { Cookie } from '@/utils'
import accountImg from '@/assets/images/user.svg?url'
import { t } from '@/lang'
interface AccountMenu {
  title: string
  path: string
}

const userStore = useUserStore()
const accountRef = ref<InstanceType<typeof FsTooltip> | null>(null)
const accountMenu = computed<AccountMenu[]>(() => [
  {
    title: t('components/layout.accountMyAccount'),
    path: '/my-account',
  },
  {
    title: t('components/layout.accountOrders'),
    path: '/order-history',
  },
  {
    title: t('components/layout.accountQuotes'),
    path: '/quote_history.html',
  },
])

const { userInfo } = storeToRefs(userStore)

const click = (item: AccountMenu) => {
  location.href = handleFsLink(item.path)
}

const isSignOutHover = ref(false)

const signOut = () => {
  Cookie.delete('token_new')
  setTimeout(() => {
    location.href = handleFsLink('/')
  }, 0)
}
</script>
<style lang="scss" scoped>
.welcome {
  text-align: center;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e5e5;
  font-weight: 600;
  @include font14;
  color: #19191a;
}

.account_menu {
  margin-top: 8px;
  display: flex;
  flex-direction: column;

  a {
    width: 100%;
    height: 100%;
    padding: 7px;
    border-radius: 4px;
    display: flex;
    cursor: pointer;
    @include font13;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    color: #707070;
    transition: all 0.3s;
    cursor: pointer;

    &:hover {
      background: #f2f2f2;
      color: #19191a;
    }
  }

  .splitLine {
    width: 100%;
    height: 1px;
    background: #eeeeee;
    margin: 8px 0;
  }

  .signOut {
    width: 100%;
    height: 100%;
    padding: 7px;

    border-radius: 4px;
    display: flex;
    cursor: pointer;
    @include font13;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    color: #707070;
    transition: all 0.3s;
    cursor: pointer;

    &:hover {
      background: #f2f2f2;
      color: #19191a;
    }
  }
}

.account_icon {
  color: #19191a;
  position: relative;
  display: block;
  border-radius: 4px;

  &::before {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;
    transition: background 0.3s ease-in-out;
    z-index: 1;
    border-radius: 4px;
  }

  &:hover {
    text-decoration: none;
    background: unset;

    &::before {
      background: color-mix(in hsl, #fff 40%, transparent);
    }
  }

  .iconfont_nav {
    width: 24px;
    height: 24px;
    border-radius: 4px;
  }
}
</style>
